import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchData, menudataSelector } from "reducers/menudata/menudata";
import Loader from "components/Loading/Loader";
import {
  DataGrid,
  GridCheckIcon,
  GridCloseIcon
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { green, red } from "@mui/material/colors";

function MenuTable() {
  const [filter, setFilter] = React.useState("");
  const navigate = useNavigate();
  const menudata = useSelector(menudataSelector);
  const dispatch = useDispatch();
  console.log("MenuData", menudata);

  useEffect(() => {
    //once
    console.log("MenuData Created");
    if ((menudata && !menudata.loaded) || menudata.needsUpdate) {
      console.log("should go get data");
      dispatch(fetchData());
    }
  }, []);

  // no data yet
  // no data yet
  // no data yet
  // no data yet
  if (!menudata) {
    console.log("no data");
    return <div>no data</div>;
  }

  // data set, but loading
  // data set, but loading
  // data set, but loading
  // data set, but loading
  if (menudata.loading) {
    console.log("data loading", menudata);
    return (
      <div className="loader-container">
        {" "}
        Loading menus ...<br></br>
        <br></br> <Loader w="25" />{" "}
      </div>
    );
  }

  // menu's loaded, show table
  // menu's loaded, show table
  // menu's loaded, show table
  // menu's loaded, show table

  const handleRowClick = (
    params, // GridRowParams
    event, // MuiEvent<React.MouseEvent<HTMLElement>>
    details // GridCallbackDetails
  ) => {
    console.log(`menu ${params.row.MENU_NUMB} clicked`);
    navigate(`/app/menuitem/${params.row.MENU_NUMB}`);
  };

  const columns = [
    {
      field: "MENU_NUMB",
      headerName: "ID",
      width: 50
    },
    {
      field: "MENU_DE",
      headerName: "Name (DE)",
      width: 200
    },
    {
      field: "MENU_EN",
      headerName: "Name (EN)",
      width: 200
    },
    {
      field: "MENU_ALGEN",
      headerName: "Allergies",
      width: 100
    },
    {
      field: "SOUP_FLAG",
      headerName: "Soup",
      width: 100,
      type: "boolean",
      renderCell: (params)=>{
        if (params.value) {
          return <GridCheckIcon style={{color:green[400]}}/>
        }
        return "";
      }
    },
    {
      field: "DEACTIVATE",
      headerName: "Active",
      width: 100,
      type: "boolean",
      renderCell: (params)=>{
        if (params.value) {
          return <GridCloseIcon style={{color:red[300]}}/>;
        }
        else{
          return <GridCheckIcon style={{color:green[400]}}/>
        }
      }
    }
  ];

  console.log("MenuTable - use data", menudata.data);

  // get data for rows
  let rowData = menudata.data.lunchMenuItems
    ? menudata.data.lunchMenuItems
    : [];

  // apply filter if needed
  if (filter != "") {
    let filteredData = [];
    Object.keys(rowData).map(key => {
      if (
        rowData[key]["MENU_DE"].toLowerCase().includes(filter.toLowerCase()) ||
        rowData[key]["MENU_EN"].toLowerCase().includes(filter.toLowerCase())
      )
        filteredData.push(rowData[key]);
    });
    rowData = filteredData;
  }

  return (
    <div>
      <div className="text-right mb-2">
        <TextField
          className=""
          id="outlined"
          label="filter"
          value={filter != "" ? filter : ""}
          onChange={event => {
            setFilter(event.target.value);
          }}
        />
      </div>
      <div style={{ height: 500, width: "100%" }}>
        <DataGrid
          onRowClick={handleRowClick}
          columns={columns}
          rows={
            // the menudata needs to be mapped, because it does not contain an ID by default (in the SAP data)
            // that is why we map it, and add an id to every row.
            // if not the DATAGRID will not work and throw an error
            // alternatively adding an ID in the backend would have worked,
            // but that will make the data dirty
            rowData
              ? rowData.map((item, index) => ({
                  id: index + 1,
                  ...item
                }))
              : []
          }
        ></DataGrid>
      </div>
    </div>
  );
}
export default MenuTable;
